import { create } from "zustand";
import { persist } from "zustand/middleware";


export interface PurchaseData {
  shipping_fee: number;
  free_shipping_fee: number;
  profile_image: string | null;
  nickname: string;
  product_list: Product[];
  seller_id: number;
}



export interface Product {
  amount: number;
  product_condition: string;
  brand_name_ko: string;
  brand_name_en: string;
  thumbnail_url: string;
  size_name: string;
  cart_id: number;
  color_id: number;
  price: number;
  product_id: number;
  size_id: number;
  product_name_ko: string;
  product_name_en: string;
  color_name: string;
  stock: number;
  seller_id: number;
}

export interface CartData {
  shipping_fee: number;
  free_shipping_fee: number;
  profile_image: string | null;
  nickname: string;
  product_list: Product[];
  seller_id: number;
}


interface Order {
  orderType: 'PURCHASE' | 'CART'; // 구매 유형을 관리
  orderItems: PurchaseData[] | CartData[] ; // 구매할 상품 배열
  cartIds: number[];
  setOrderType: (type: 'PURCHASE' | 'CART') => void;
  setOrder: (items: PurchaseData[] | CartData []) => void; // 새로 구매할 상품으로 대체
  clearOrder: () => void; // 상품 초기화
  getOrderItems: <T>() => T[]; // 제네릭을 사용하여 타입을 지정
  setCartIds: (ids: number[]) => void; // 징바구니 -> 결제 페이지 체크된 ID
}

const useOrderStore = create<Order>()(
  persist(
    (set, get) => ({
      orderType: 'PURCHASE', 
      orderItems: [], 
      cartIds: [], 
      setOrderType: (type: 'PURCHASE' | 'CART') => set({ orderType: type }),
      setOrder: (items: PurchaseData[] | CartData[] ) => set({ orderItems: items }), // 새로 구매할 상품으로 대체
      setCartIds: (ids: number[]) => set({ cartIds: ids }),
      clearOrder: () => set({ orderItems: [], cartIds: [] }), // 모든 상품 초기화
      getOrderItems: <T>() => get().orderItems as T[], // 현재 구매할 상품 리스트 반환
    }),
    {
      name: 'order-storage', // 로컬스토리지에 저장되는 키
    }
  )
);

export default useOrderStore;
